var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Pivot',{ref:"pivot",attrs:{"toolbar":"","height":600,"shareReportConnection":{
      url: 'https://olap.flexmonster.com:9500',
    },"global":{
      localization: 'https://cdn.flexmonster.com/loc/pt.json',
      options: {
        datePattern: 'yyyy/MM/dd'
      }
    },"customizeCell":_vm.customizeCellFunction,"beforetoolbarcreated":_vm.customizeToolbar,"licenseKey":_vm.flexmonsterKey,"ready":_vm.onReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }